const content = {
  marginBottom: '5px',
}

export default {content};


// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Radio/components/RadioStationsGroup/components/RadioStation/style.js